module.exports = __webpack_public_path__ + "static/media/TB.8268f614.svg";